import React from "react";
import Button from '../Button';
import PropTypes from 'prop-types';

export default class RoundedButton extends React.PureComponent {
    render() {
        let { className } = this.props;

        return (
            <Button className={'rounded-button ' + className} {...this.props}/>
        );
    }
}

RoundedButton.propTypes = {
    className: PropTypes.string,
};
